import { LoanLightButton } from "@/legacy-components/button";
import { createComponent } from "@lit/react";
import React from "react";

export const LoanLightButtonWrapper = createComponent({
  react: React,
  tagName: "loanlight-button",
  elementClass: LoanLightButton,
});
